import { initials, animations } from '../index';
import { inApp } from '../../utils';

export function sectionsEnter(el, delay = 0) {
  const ctx = el;
  const text = ctx.querySelector('.phase__question h2');
  const answer = ctx.querySelector('.phase__answer');
  const gridHide = ctx.querySelector('.grid-hide');
  ctx.style.opacity = 0;
  let anim = null;

  ctx.style.opacity = 1;
  initials.get('grid-hide')(gridHide);
  initials.get('paragraph')(text);
  animations.get('grid-hide')(gridHide, delay);
  anim = animations.get('paragraph')(text, delay + 300);

  if (answer) {
    const animationType = answer.dataset.type;
    initials.get(animationType)(answer);
    animations.get(animationType)(answer, animationType === 'list' && inApp() ? delay + 500 : delay);
  }

  return anim;
}

export function sectionsLeave(el, delay = 0) {
  const ctx = el;
  const question = ctx.querySelector('.phase__question h2');
  const answer = ctx.querySelector('.phase__content p');
  const gridHides = [...ctx.querySelectorAll('.grid-hide')];

  animations.get('paragraph-out')(question, delay);
  animations.get('paragraph-out')(answer, delay + 200);
  return animations.get('grid-hide-out')(gridHides, inApp() ? delay + 500 : delay + 1000);
}
